export default {
  header: 'Ingredients',
  total: 'Total',
};
